import { FC, useState } from 'react';

import { router } from '@inertiajs/react';

import { InfiniteScrollTrigger } from '../../../components/shared/InfiniteScrollTrigger';

interface Props {
    url: string;
    nextPage: number | null;
    params?: Record<string, string | number>;
}

export const Pagination: FC<Props> = ({ url, nextPage, params = {} }) => {
    const [loading, setLoading] = useState(false);

    const loadMore = () => {
        if (!nextPage || loading) return;

        setLoading(true);

        router.get(
            url,
            { ...params, page: nextPage },
            {
                preserveScroll: true,
                preserveState: true,
                preserveUrl: true,
                only: ['orders', 'nextPage'],
                onFinish: () => {
                    setLoading(false);
                },
            },
        );
    };

    if (!nextPage) return null;

    return <InfiniteScrollTrigger loading={loading} onLoadMore={loadMore} />;
};
